import { useSearchParams } from 'react-router-dom';
import { DEFAULT_RANGE, isRangeKey, type RangeKey } from './range';

// Single source of truth for the dashboard range. URL-driven so refreshes and
// shared links preserve the view.
export function useRange(): [RangeKey, (next: RangeKey) => void] {
  const [params, setParams] = useSearchParams();
  const raw = params.get('range');
  const current = isRangeKey(raw) ? raw : DEFAULT_RANGE;

  function set(next: RangeKey): void {
    const updated = new URLSearchParams(params);
    if (next === DEFAULT_RANGE) updated.delete('range');
    else updated.set('range', next);
    setParams(updated, { replace: true });
  }

  return [current, set];
}
